import { FC } from 'react';
import { LoadingIndicatorSpinnerBar } from '@abtasty/design-system';
import styles from './PageLoader.module.scss';

type PageLoaderProps = { text: string };

export const PageLoader: FC<PageLoaderProps> = ({ text }) => (
  <div className={styles.container}>
    <LoadingIndicatorSpinnerBar />
    <span className={styles.text}>{text}</span>
  </div>
);
